__turbopack_context__.v({
  "close": "style-module-scss-module__SLK0DG__close",
  "component": "style-module-scss-module__SLK0DG__component",
  "exp-theme": "style-module-scss-module__SLK0DG__exp-theme",
  "exp-wrapper": "style-module-scss-module__SLK0DG__exp-wrapper",
  "fake-search": "style-module-scss-module__SLK0DG__fake-search",
  "filter-button": "style-module-scss-module__SLK0DG__filter-button",
  "full-screen-search-wrapper": "style-module-scss-module__SLK0DG__full-screen-search-wrapper",
  "full-width": "style-module-scss-module__SLK0DG__full-width",
  "mobile-input": "style-module-scss-module__SLK0DG__mobile-input",
  "screen-take-over": "style-module-scss-module__SLK0DG__screen-take-over",
  "search-button-container": "style-module-scss-module__SLK0DG__search-button-container",
  "search-circle-btn": "style-module-scss-module__SLK0DG__search-circle-btn",
  "search-icon-long": "style-module-scss-module__SLK0DG__search-icon-long",
  "search-options": "style-module-scss-module__SLK0DG__search-options",
  "search-wrapper": "style-module-scss-module__SLK0DG__search-wrapper",
  "suggested-location-dropdown": "style-module-scss-module__SLK0DG__suggested-location-dropdown",
});
